import { useMemo } from 'react'

import { ClickToCopy, Table, Tooltip } from '@/components'
import { Warranty } from '@/models'

type DeviceDetailsTeslaProps = {
    warranty: Warranty
}

export const DeviceDetailsTesla = ({ warranty }: DeviceDetailsTeslaProps) => {
    const rows = useMemo(() =>
        warranty.homeowner.system.allDevices.map(item => ({
            id: item.id,
            devices: item.category.title,
            din: item.din
                ? <div className="flex gap-1 items-center">
                    <Tooltip content={item.din} className="truncate">{item.din}</Tooltip>
                    <ClickToCopy content={item.din}/>
                </div>
                : '-',
            part_number: item.part_number
                ? <div className="flex gap-1 items-center">
                    <Tooltip content={item.part_number} className="truncate">{item.part_number}</Tooltip>
                    <ClickToCopy content={item.part_number}/>
                </div>
                : '-',
            serial_number: item.serial_number
                ? <div className="flex gap-1 items-center">
                    <Tooltip content={item.serial_number} className="truncate">{item.serial_number}</Tooltip>
                    <ClickToCopy content={item.serial_number}/>
                </div>
                : '-',
            max_discharge_power: item.nameplate_max_discharge_power_watts?.format(),
            max_charge_power: item.nameplate_max_charge_power_watts?.format(),
            energy: item.nameplate_energy_watt_hours?.format()
        })), [])

    return <>
        <h2 className="border-b border-orange-400 pb-4 mb-4 text-lg font-semibold text-gray-900">
            Device Details
        </h2>
        <p className="text-gray-500 text-xs mb-4">
            Last updated at {warranty.homeowner?.monitoring_data?.updated_at
                ? warranty.homeowner?.monitoring_data?.updated_at.format({
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                })
                : '-'}
        </p>

        <Table
            options={{
                useQueryParams: false,
                pagination: false,
                sortable: false
            }}
            className="stripped-table"
            columns={[
                {
                    field: 'devices',
                    title: <div className="font-normal text-sm">Devices</div>,
                    className: 'py-6',
                    cellClassName: () => 'bg-orange-50 text-gray-900 text-lg font-semibold !py-6'
                },
                {
                    field: 'din',
                    title: <div className="font-normal text-sm">DIN</div>,
                    cellClassName: () => 'bg-white text-gray-500'
                },
                {
                    field: 'serial_number',
                    title: <div className="font-normal text-sm">Serial Number</div>,
                    cellClassName: () => 'bg-white text-gray-500'
                },
                {
                    field: 'part_number',
                    title: <div className="font-normal text-sm">Part Number</div>,
                    cellClassName: () => 'bg-white text-gray-500'
                },
                {
                    field: 'max_discharge_power',
                    title: <div className="font-normal text-sm">Max Discharge Power (W)</div>,
                    cellClassName: () => 'bg-white text-gray-500'
                },
                {
                    field: 'max_charge_power',
                    title: <div className="font-normal text-sm">Max Charge Power (W)</div>,
                    cellClassName: () => 'bg-white text-gray-500'
                },
                {
                    field: 'energy',
                    title: <div className="font-normal text-sm">Energy (Wh)</div>,
                    cellClassName: () => 'bg-white text-gray-500'
                }
            ]}
            rows={rows}
        />
    </>
}
